import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Box, MenuItem, Select } from "@material-ui/core";
import {
  getPatientsWithoutParamsRequest,
  getAilingPatientsRequest,
  getChronicPatientsRequest,
  getRecoveringPatientsRequest,
} from "../../PatientApiActions";
import moment from "moment";
import { getDoctorsForOrgRequest } from "../../../Doctors/DoctorApiActions";
import {
  AthleteType,
  PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
} from "../../../../utilities/constants";
import { getRolesRequest } from "../../../Users/UsersApiActions";
import { useStyles } from "./styles";
import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";

const Patients = ({
  selectedDept,
  depts,
  getRoles,
  user,
  getDoctors,
  getPatientsWithoutParams,
  athletesWithoutParams,
  recoveringAthletes,
  getAilingPatients,
  ailingAthletes,
  getChronicPatients,
  chronicAthletes,
  getRecoveringPatients,
}) => {
  const classes = useStyles();
  const [initialDoctors, setInitialDoctors] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [userRole, setUserRole] = useState("");
  const history = useHistory();
  const [filter, setFilter] = useState("ALL");
  const [paginationParams, setPaginationParams] = useState({
    page: 0,
    rowsPerPage: PAGE_SIZE,
    searchData: { name: "", phone: "" },
  });

  const searchTimerRef = useRef(null);

  useEffect(() => {
    if (user?.Roles?.length > 0) {
      setUserRole(user.Roles[0].name);
    }
  }, [user]);

  useEffect(() => {
    if (!userRole) return;

    let teamId = selectedDept?.team_id || depts?.teams?.[0]?.team_id;
    if (!teamId) return;

    if (userRole === "Doctor") {
      if (filter === "AILING") {
        getAilingPatients(teamId, paginationParams);
      } else if (filter === "CHRONIC") {
        getChronicPatients(teamId, paginationParams);
      } else if (filter === "RECOVERING") {
        getRecoveringPatients(teamId, paginationParams);
      } else {
        getPatientsWithoutParams(
          selectedDoctorId || teamId,
          selectedDoctorId ? AthleteType.USER : AthleteType.TEAM,
          paginationParams
        );
      }
    } else {
      getPatientsWithoutParams(
        selectedDoctorId || teamId,
        selectedDoctorId ? AthleteType.USER : AthleteType.TEAM,
        paginationParams
      );
    }
  }, [
    userRole,
    selectedDept?.team_id,
    depts?.teams?.length,
    paginationParams,
    filter,
    selectedDoctorId,
  ]);

  useEffect(() => {
    if (userRole !== "Receptionist") return;
    if (!athletesWithoutParams?.rows?.length || initialDoctors.length > 0)
      return;

    const firstPatient = athletesWithoutParams.rows[0];
    const orgId =
      firstPatient?.Teams?.[0]?.OrganizationId ||
      firstPatient?.Appointments?.[0]?.OrganizationId;

    if (orgId) {
      const data = {
        page: 0,
        rowsPerPage: 100,
        searchData: "",
      };

      getDoctors(orgId, data, true)
        .then((resData) => {
          if (resData?.rows) {
            const doctorList = resData.rows
              .filter((doc) => doc.role === "Doctor")
              .map((doc) => ({
                id: doc.userId,
                name: `${doc.firstName} ${doc.lastName}`,
              }));

            setDoctors(doctorList);
            setInitialDoctors(doctorList);
          }
        })
        .catch((err) => console.error("Error fetching doctors:", err));
    }
  }, [athletesWithoutParams, userRole, initialDoctors.length, getDoctors]);

  function getStatus(patient) {
    if (filter === "AILING") return "Ailing";
    if (filter === "CHRONIC") return "Chronic";
    if (filter === "RECOVERING") return "Recovering";
    return "All";
  }

  const getFilteredPatients = () => {
    if (userRole === "Doctor") {
      if (filter === "AILING") return ailingAthletes?.rows || [];
      if (filter === "CHRONIC") return chronicAthletes?.rows || [];
      if (filter === "RECOVERING") return recoveringAthletes?.rows || [];
    }
    return athletesWithoutParams?.rows || [];
  };

  const getTotalCount = () => {
    if (userRole === "Doctor") {
      if (filter === "AILING") return ailingAthletes?.count || 0;
      if (filter === "CHRONIC") return chronicAthletes?.count || 0;
      if (filter === "RECOVERING") return recoveringAthletes?.count || 0;
    }
    return athletesWithoutParams?.count || 0;
  };

  const patientsData = getFilteredPatients().map((patient) => {
    return {
      ...patient,
      id: patient.id || patient.patientId,
      fullName:
        patient?.externalReport?.attributes?.name?.trim() ||
        `${patient.firstName || ""} ${patient.lastName || ""}`.trim(),
      mobile: patient.mobile || "N/A",
      dob: patient?.externalReport?.attributes?.time_of_birth
        ? new Date(
            patient.externalReport.attributes.time_of_birth
          ).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : "N/A",
      gender:
        patient?.externalReport?.attributes?.gender?.trim() ||
        patient.gender ||
        "N/A",
      lastAppointment: patient.lastAppointmentDate
        ? moment(patient.lastAppointmentDate).format("DD MMM YYYY")
        : "-",
      nextAppointment: patient.nextAppointmentDate
        ? moment(patient.nextAppointmentDate).format("DD MMM YYYY")
        : "-",
      totalAppointments: patient.totalAppointments || 0,
      status: userRole === "Doctor" ? getStatus(patient) : undefined,
    };
  });

  const handleRowClick = (event, rowData) => {
    if (rowData?.id) {
      history.push(`/patients/${rowData.id}`);
    }
  };

  const handleDoctorChange = (userId) => {
    setSelectedDoctorId(userId);
    let data = Object.assign({}, paginationParams);
    data.page = 0;
    setPaginationParams(data);
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    let data = Object.assign({}, paginationParams);
    data.page = 0;
    setPaginationParams(data);
  };

  const handleSearchChange = (searchText) => {
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }

    searchTimerRef.current = setTimeout(() => {
      let data = { ...paginationParams };
      data.page = 0;

      if (/^\d+$/.test(searchText)) {
        data.searchData = { name: "", phone: searchText };
      } else {
        data.searchData = { name: searchText, phone: "" };
      }

      setPaginationParams(data);
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  return (
    <Box style={{ paddingTop: "1.5rem", paddingBottom: "3rem" }}>
      <Box className={classes.athletesContainer}>
        <MaterialTable
          title="Patients"
          columns={[
            {
              title: "Name",
              field: "fullName",
              render: (rowData) => {
                return (
                  <span
                    style={{
                      color: "#1976d2",
                      cursor: "pointer",
                      fontWeight: "normal",
                    }}
                  >
                    {rowData.fullName}
                  </span>
                );
              },
            },
            { title: "Phone", field: "mobile" },
            { title: "DOB", field: "dob" },
            { title: "Gender", field: "gender" },
            { title: "Last Appointment", field: "lastAppointment" },
            { title: "Next Appointment", field: "nextAppointment" },
            { title: "Total Appointments", field: "totalAppointments" },
          ]}
          data={patientsData}
          pages={Math.ceil(getTotalCount() / paginationParams.rowsPerPage)}
          totalCount={getTotalCount()}
          page={paginationParams.page}
          options={{
            search: true,
            paging: true,
            toolbar: true,
            pageSize: paginationParams.rowsPerPage,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
            debounceInterval: 500,
            rowStyle: {
              cursor: "pointer",
            },
            headerStyle: {
              backgroundColor: "#f5f5f5",
              fontWeight: "bold",
            },
            searchFieldAlignment: "left",
            searchAutoFocus: true,
            toolbarButtonAlignment: "left",
            showFirstLastPageButtons: false,
          }}
          onSearchChange={(searchText) => {
            handleSearchChange(searchText);
          }}
          onChangeRowsPerPage={(pageSize) => {
            let data = Object.assign({}, paginationParams);
            data.rowsPerPage = pageSize;
            data.page = 0;
            setPaginationParams(data);
          }}
          onChangePage={(page) => {
            let data = Object.assign({}, paginationParams);
            data.page = page;
            setPaginationParams(data);
          }}
          actions={[
            userRole === "Receptionist"
              ? {
                  icon: () => (
                    <Select
                      value={selectedDoctorId || ""}
                      onChange={(e) => handleDoctorChange(e.target.value)}
                      displayEmpty
                      variant="outlined"
                      style={{ minWidth: 220 }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return <>All Doctors</>;
                        }
                        const selectedDoctor = doctors.find(
                          (d) => d.id === selected
                        );
                        return selectedDoctor?.name || "";
                      }}
                    >
                      <MenuItem value="">All Doctors</MenuItem>
                      {initialDoctors.map((doc) => (
                        <MenuItem key={doc.id} value={doc.id}>
                          {doc.name}
                        </MenuItem>
                      ))}
                    </Select>
                  ),
                  tooltip: "Filter by Doctor",
                  isFreeAction: true,
                }
              : userRole === "Doctor"
              ? {
                  icon: () => (
                    <Select
                      value={filter}
                      onChange={(e) => handleFilterChange(e.target.value)}
                      variant="outlined"
                      style={{
                        backgroundColor: "#fff",
                        minWidth: "200px",
                        marginRight: "16px",
                      }}
                    >
                      <MenuItem value="ALL">All Patients</MenuItem>
                      <MenuItem value="AILING">Ailing</MenuItem>
                      <MenuItem value="CHRONIC">Chronic</MenuItem>
                      <MenuItem value="RECOVERING">Recovering</MenuItem>
                    </Select>
                  ),
                  tooltip: "Filter by Status",
                  isFreeAction: true,
                }
              : {
                  icon: () => <span />,
                  isFreeAction: true,
                  tooltip: "",
                },
          ]}
          onRowClick={handleRowClick}
          localization={{
            toolbar: {
              searchPlaceholder: "Search by name/phone",
            },
            body: {
              emptyDataSourceMessage:
                "No patients found matching your criteria",
            },
            pagination: {
              labelDisplayedRows: "{from}-{to} of {count}",
            },
          }}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  athletesWithoutParams: state.athletes.athletes,
  selectedDept: state.ayucareUsers.selectedDept,
  depts: state.ayucareUsers.depts,
  recoveringAthletes: state.athletes.recoveringAthletes,
  ailingAthletes: state.athletes.ailingAthletes,
  chronicAthletes: state.athletes.chronicAthletes,
  user: state.auth.loggedInUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getRoles: () => {
      return dispatch(getRolesRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getPatientsWithoutParams: (id, type, data) => {
      return dispatch(getPatientsWithoutParamsRequest(id, type, data)).then(
        (res) => Promise.resolve(res),
        (error) => Promise.reject(error)
      );
    },
    getRecoveringPatients: (teamId, data) => {
      return dispatch(getRecoveringPatientsRequest(teamId, data)).then(
        (res) => Promise.resolve(res),
        (error) => Promise.reject(error)
      );
    },
    getAilingPatients: (teamId, data) => {
      return dispatch(getAilingPatientsRequest(teamId, data)).then(
        (res) => Promise.resolve(res),
        (error) => Promise.reject(error)
      );
    },
    getChronicPatients: (teamId, data) => {
      return dispatch(getChronicPatientsRequest(teamId, data)).then(
        (res) => Promise.resolve(res),
        (error) => Promise.reject(error)
      );
    },
    getDoctors: (id, data, isHideLoader) => {
      return dispatch(getDoctorsForOrgRequest(id, data, isHideLoader)).then(
        (res) => Promise.resolve(res),
        (error) => Promise.reject(error)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Patients);
